import { useMemo } from 'react'

import { Text } from '@chakra-ui/react'

import { ButtonTag } from '@/components/ui'
import {
  ResolutionSegment,
  ResolutionSegmentType,
} from '@/graphql/generated/schemas'

import { getSegmentsToRender } from '../utils/utils'

interface SegmentsIProps {
  segments: ResolutionSegment[]
  shouldTruncate: boolean
  isExpanded: boolean
  characterLimit: number
  onEventRefClick: (detectedAt: string, externalId: string) => void
  onOpenTraceLog: () => void
}

export const ResolutionSegments = ({
  segments,
  shouldTruncate,
  isExpanded,
  characterLimit,
  onEventRefClick,
  onOpenTraceLog,
}: SegmentsIProps) => {
  const segmentsToRender = useMemo(
    () =>
      getSegmentsToRender(segments, shouldTruncate, isExpanded, characterLimit),
    [segments, shouldTruncate, isExpanded, characterLimit]
  )

  return (
    <>
      {segmentsToRender.map(({ segment, text }, index) => (
        <Segment
          key={index}
          onEventRefClick={onEventRefClick}
          onOpenTraceLog={onOpenTraceLog}
          segment={segment}
          textToShow={text}
        />
      ))}
    </>
  )
}

interface SegmentIProps {
  segment: ResolutionSegment
  textToShow: string
  onEventRefClick: (detectedAt: string, externalId: string) => void
  onOpenTraceLog: () => void
}

const Segment = ({
  segment,
  textToShow,
  onEventRefClick,
  onOpenTraceLog,
}: SegmentIProps) => {
  if (segment.segmentType === ResolutionSegmentType.Text) {
    return <Text as='span'>{textToShow}</Text>
  }

  if (segment.segmentType === ResolutionSegmentType.EventRef) {
    const hasEventData = segment.detectedAt && segment.externalId
    return (
      <>
        {' '}
        <ButtonTag
          lineHeight='22px'
          onClick={
            hasEventData
              ? () => onEventRefClick(segment.detectedAt, segment.externalId)
              : onOpenTraceLog
          }
          style={{
            display: 'inline-flex',
            padding: '1px 8px',
            verticalAlign: 'middle',
          }}
        >
          {textToShow}
        </ButtonTag>{' '}
      </>
    )
  }

  return null
}
